import axios from '@utils/axios';
import router from '@router/router';
import DoctorsIntroPlaceholder from '@resources/doctorsintroplaceholder';

function saveToLocalStorage(changed, intro, productId, key) {
  if (changed) {
    const localDoctorsIntro = {
      productId: Number(productId),
      doctorIntro: intro,
      doctorIntroChange: new Date().toLocaleString()
    };
    localStorage.setItem(key, JSON.stringify(localDoctorsIntro));
  }
}

function getLocalStorageKey(state, key) {
  return `${key}_${state.productId}`;
}

const editProduct = {
  state: {
    productId: 0,
    productCategoryId: 0,
    doctorIntro: '',
    doctorIntroReproductiveGenetics: '',
    doctorIntroChanged: false,
    doctorIntroReproductiveGeneticsChanged: false,
    product: {},
    publishedAt: '',
    generatedAt: '',
    status: 0,
    customerName: '',
    ready: false,
    lastChangeAt: '',
    customerUnderage: false,
    doctorsIntroLastChange: '',
    doctor: '',
    isInDoctorSection: false,
    isArchived: false,
    productType: '',
    doctorIntroReproductiveGeneticsEnabled: false,
    partner: null,
    partnerId: null
  },
  getters: {
    localStorageDoctorIntroKey: (state) => () => getLocalStorageKey(state, 'doctors_intro'),
    localStorageDoctorIntroReproductiveGeneticsKey: (state) => () => getLocalStorageKey(state, 'doctors_intro_reproductive_genetics')
  },
  mutations: {
    setProductId(state, val) {
      state.productId = val;
    },
    setProductCategoryId(state, val) {
      state.productCategoryId = val;
    },
    setProductCategory(state, val) {
      const category = val;
      const index = state.product.categories.findIndex((x) => x.id === category.id);
      state.product.categories[index].description = category.description;
      state.product.categories[index].geneInformation = category.geneInformation;
      state.product.categories[index].phenotypes = category.phenotypes;
      state.product.categories[index].references = category.references;
      state.product.categories[index].subcategories = category.subcategories;
    },
    setDoctorIntro(state, val) {
      state.doctorIntro = val;
    },
    setDoctorIntroReproductiveGenetics(state, val) {
      state.doctorIntroReproductiveGenetics = val;
    },
    setDoctorIntroChanged(state, val) {
      state.doctorIntroChanged = val;
    },
    setDoctorIntroReproductiveGeneticsChanged(state, val) {
      state.doctorIntroReproductiveGeneticsChanged = val;
    },
    setProduct(state, product) {
      state.product = product;
    },
    setPublishedAt(state, published) {
      state.publishedAt = published;
    },
    setGeneratedAt(state, generated) {
      state.generatedAt = generated;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setCustomerName(state, name) {
      state.customerName = name;
    },
    setReady(state, ready) {
      state.ready = ready;
    },
    setLastChangeAt(state, at) {
      state.lastChangeAt = at;
    },
    setCustomerUnderage(state, underage) {
      state.customerUnderage = underage;
    },
    setDoctorsIntroLastChange(state, change) {
      state.doctorsIntroLastChange = change;
    },
    setDoctor(state, doctor) {
      state.doctor = doctor;
    },
    setIsInDoctorSection(state, inDoctorSection) {
      state.isInDoctorSection = inDoctorSection;
    },
    setIsArchived(state, archived) {
      state.isArchived = archived;
    },
    setProductType(state, productType) {
      state.productType = productType;
    },
    setDoctorIntroReproductiveGeneticsEnabled(state, val) {
      state.doctorIntroReproductiveGeneticsEnabled = val;
    },
    setPartner(state, val) {
      state.partner = val;
    },
    setPartnerId(state, val) {
      state.partnerId = val;
    }
  },
  actions: {
    setDoctorIntro(context, val) {
      context.commit('setDoctorIntro', val);
      context.commit('setDoctorIntroChanged', true);
      saveToLocalStorage(
        context.state.doctorIntroChanged,
        context.state.doctorIntro,
        context.state.productId,
        context.getters.localStorageDoctorIntroKey(context.state)
      );
    },
    setDoctorIntroReproductiveGenetics(context, val) {
      context.commit('setDoctorIntroReproductiveGenetics', val);
      context.commit('setDoctorIntroReproductiveGeneticsChanged', true);
      saveToLocalStorage(
        context.state.doctorIntroReproductiveGeneticsChanged,
        context.state.doctorIntroReproductiveGenetics,
        context.state.productId,
        context.getters.localStorageDoctorIntroReproductiveGeneticsKey(context.state)
      );
    },
    fetchCategory(context) {
      return axios.get('admin/products/getcategory', {
        params: {
          ProductId: context.state.productId,
          ProductCategoryId: context.state.productCategoryId
        }
      })
        .then((res) => {
          if (res.status === 404) {
            // router.push({ name: 'admin.products.view' });
          } else if (res.status === 200) {
            context.commit('setProductCategory', res.data.result.content.categories[0]);
            Promise.resolve(true);
          }
        }).catch(() => {
          // router.push({ name: 'admin.dashboard' });
        });
    },
    fetchProduct(context) {
      return axios.get('admin/products/getproduct', {
        params: {
          ProductId: context.state.productId
        }
      })
        .then((res) => {
          let result = false;
          context.commit('setDoctorIntroChanged', false);
          context.commit('setDoctorIntroReproductiveGeneticsChanged', false);

          if (res.status === 404) {
            router.push({ name: 'admin.customers.products.view' });
          } else if (res.status === 200) {
            context.commit('setStatus', res.data.result.status);
            context.commit('setCustomerName', res.data.result.customerName);
            context.commit('setGeneratedAt', res.data.result.generatedAt);
            context.commit('setPublishedAt', res.data.result.publishedAt);
            if (res.data.result.doctorIntro !== null && res.data.result.doctorIntro.length > 0) {
              context.commit('setDoctorIntro', res.data.result.doctorIntro);
            } else {
              const dateOfBirth = new Date(res.data.result.dateOfBirth).toLocaleDateString('cz-CZ');
              context.commit('setDoctorIntro', DoctorsIntroPlaceholder(res.data.result.customerName, dateOfBirth, res.data.result.address, res.data.result.gender, res.data.result.analysisResults));
            }
            context.commit('setDoctorIntroReproductiveGenetics', res.data.result.doctorIntroReproductiveGenetics);

            context.commit('setProduct', res.data.result.content);
            context.commit('setLastChangeAt', res.data.result.lastChangeAt);
            context.commit('setDoctorsIntroLastChange', res.data.result.doctorsIntroLastChange);
            context.commit('setCustomerUnderage', res.data.result.customerUnderage);
            context.commit('setDoctor', res.data.result.doctor || '');
            context.commit('setReady', true);
            context.commit('setDoctorIntroChanged', false);
            context.commit('setDoctorIntroReproductiveGeneticsChanged', false);
            context.commit('setIsInDoctorSection', res.data.result.isInDoctorSection);
            context.commit('setIsArchived', res.data.result.isArchived);
            context.commit('setProductType', res.data.result.productType);
            context.commit('setDoctorIntroReproductiveGeneticsEnabled', res.data.result.doctorIntroReproductiveGeneticsEnabled);
            context.commit('setPartner', res.data.result.assignedCustomer);
            context.commit('setPartnerId', res.data.result.assignedCustomerId);
            result = true;
          } else if (res.status === 204) {
            router.push({ name: 'admin.customers.products.view' });
          }
          return Promise.resolve(result);
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    editProduct(context) {
      return axios.patch('admin/products/', {
        Id: Number(context.state.productId),
        Status: context.state.status,
        DoctorIntro: context.state.doctorIntro,
        DoctorIntroReproductiveGenetics: context.state.doctorIntroReproductiveGenetics
      })
        .then(() => {
          context.commit('setDoctorIntroChanged', false);
          localStorage.removeItem(context.getters.localStorageDoctorIntroKey(context.state));
          context.commit('setDoctorIntroReproductiveGeneticsChanged', false);
          localStorage.removeItem(context.getters.localStorageDoctorIntroReproductiveGeneticsKey(context.state));
        });
    },
    resetContext(context) {
      context.commit('setStatus', 1);
      context.commit('setCustomerName', '');
      context.commit('setGeneratedAt', '');
      context.commit('setPublishedAt', '');
      context.commit('setDoctorIntro', '');
      context.commit('setDoctorIntroReproductiveGenetics', '');
      context.commit('setCustomerUnderage', false);
      context.commit('setLastChangeAt', '');
      context.commit('setProduct', {});
      context.commit('setReady', false);
      context.commit('setIsInDoctorSection', false);
      context.commit('setIsArchived', false);
      context.commit('setProductType', '');
      context.commit('setDoctorIntroReproductiveGeneticsEnabled', false);
      context.commit('setPartner', null);
      context.commit('setPartnerId', null);
    }
  },
  namespaced: true
};

export default editProduct;
